module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-abstract-kimberly-1.2ce186cd.jpg";